import {ReactComponent} from '../app'
import OverlayContent from '../components/layout/OverlayContent'
import App from '../app/App'

export default class FoodMenuPage extends ReactComponent {
  state = {
    lobsterFamilyMenu: [],
    lobsterFamilyMenuLoading: true,
    lobsterFamilyMenuActive: true,
  }

  async componentDidMount() {
    try {
      const response = await fetch(
        App.API_URL + '/sushitime-menu.php'
      );

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const categories = await response.json();

      if (!Array.isArray(categories)) {
        throw new Error('Menu API returned an invalid response');
      }

      void this.updateState({
        lobsterFamilyMenu: categories,
        lobsterFamilyMenuLoading: false,
      });
    } catch (error) {
      console.error('Error fetching menu:', error);

      void this.updateState({
        lobsterFamilyMenuLoading: false,
      });
    }
  }

  render() {
    return (
      <>
        <OverlayContent
          classes="food-menu"
          showHeader={false}
          loading={this.state.lobsterFamilyMenuLoading}
          active={this.state.lobsterFamilyMenuActive}
          onClose={() => {
            void this.updateState({lobsterFamilyMenuActive: false})
          }}
        >

        <h1 className="page-title">Menu</h1>
        {Array.isArray(this.state.lobsterFamilyMenu) && this.state.lobsterFamilyMenu.map((category, categoryIndex) => (
            <section
              className="menu-category"
              key={`${category.name}-${categoryIndex}`}
            >
              <h2 className="menu-category-name">
                {category.name}
              </h2>

              {Array.isArray(category.products) && category.products.map((product, productIndex) => (
                <div
                  className="item-wrapper"
                  key={`${product.name}-${productIndex}`}
                >
                  <span className="menu-product-name meta">
                    {product.name}
                  </span>

                  {product.size && (
                    <span className="type-size meta">
                      {product.size}
                    </span>
                  )}

                  <span className="price">
                    {product.price}
                  </span>
                </div>
              ))}
            </section>
          ))}
          
        </OverlayContent>
      </>
    )
  }}